module.exports = __webpack_public_path__ + "img/stapler_vr.b82249f0.png";